class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener("keyup", (event) => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener("click", this.close.bind(this));

    this.summaryToggle.setAttribute("role", "button");
    this.scrollY = 0;
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  lockScroll() {
    this.scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
}

  unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, this.scrollY);
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open") ? this.close() : this.open(event);
  }
onBodyClick(event) {
  const cartDrawer = document.querySelector("cart-drawer");
  const isCartDrawerOpen = cartDrawer?.classList.contains("active") || cartDrawer?.isOpen;
  if (isCartDrawerOpen) return;
  const predictiveSearch = this.querySelector("predictive-search");
  if (predictiveSearch ) {
    return;
  }
  if (!this.contains(event.target) || event.target.classList.contains("modal-overlay")) this.close(false);
}


  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    this.lockScroll();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    const quickAddIsOpen = document.querySelector(".quick-add-modal[open]");
    if (!quickAddIsOpen) {
      document.body.classList.remove("overflow-hidden");
    }
    this.unlockScroll();
  }
}

customElements.define("details-modal", DetailsModal);
